import type { ResultOf } from '@graphql-typed-document-node/core';
import { graphql } from 'src/gql';

export const ClientPortalTransferAdvisorQuery = graphql(/* GraphQL */ `
  query ClientPortalTransferAdvisor($id: ID!, $householdId: ID) {
    client(id: $id) {
      id
      household(id: $householdId) {
        id
        advisor {
          id
        }
        advisoryTeam: assignedAdvisors(advisorRoleOnly: true) {
          id
          displayEmail
          user {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
`);

export type ClientPortalTransferAdvisorResult = ResultOf<typeof ClientPortalTransferAdvisorQuery>;

export type ClientPortalTransferAdvisorTeamMember =
  ClientPortalTransferAdvisorResult['client']['household']['advisoryTeam'][number];
